"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconClipboard = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconClipboard = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsxs)("svg", _objectSpread(_objectSpread({
    width: "26",
    height: "36",
    viewBox: "0 0 26 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M22.4005 27.0954C22.0411 26.8392 21.5411 26.922 21.2849 27.2814L18.9099 30.608L17.4364 29.1345C17.1239 28.822 16.6177 28.822 16.3052 29.1345C15.9927 29.447 15.9927 29.9533 16.3052 30.2658L18.4474 32.4064C18.5989 32.558 18.8021 32.6408 19.013 32.6408C19.0349 32.6408 19.0568 32.6392 19.0786 32.6377C19.313 32.6189 19.5271 32.497 19.6646 32.3048L22.5896 28.2096C22.8443 27.8518 22.7614 27.3518 22.4005 27.0955V27.0954Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M2.72021 34.3799H15.153C15.2202 34.3799 15.2859 34.3689 15.3484 34.3533C16.4546 35.3721 17.9265 36.0002 19.5452 36.0002C22.9686 36.0002 25.7532 33.2158 25.7532 29.7938C25.7532 27.9813 24.9673 26.3531 23.7251 25.2174V7.69691C23.7251 6.1969 22.5047 4.97658 21.0047 4.97658H19.1329C18.4251 3.77501 17.1219 2.96565 15.6297 2.96565H15.5453C15.175 1.27188 13.6657 0 11.8625 0C10.061 0 8.55004 1.27188 8.18284 2.96565H8.09847C6.60626 2.96565 5.30314 3.77501 4.59534 4.97658H2.72033C1.22032 4.97658 0 6.1969 0 7.69691V31.6562C0 33.1577 1.22032 34.3796 2.72033 34.3796L2.72021 34.3799ZM24.1531 29.7939C24.1531 32.333 22.0859 34.4003 19.5451 34.4003C17.0043 34.4003 14.9386 32.3331 14.9386 29.7939C14.9386 27.2532 17.0043 25.1874 19.5451 25.1874C22.0857 25.1859 24.1531 27.2531 24.1531 29.7939ZM8.09823 4.56578H8.89667C9.33887 4.56578 9.69667 4.20796 9.69667 3.76578C9.69667 2.57201 10.6686 1.60013 11.8623 1.60013C13.0561 1.60013 14.028 2.57201 14.028 3.76578C14.028 4.20798 14.3858 4.56578 14.828 4.56578H15.6264C16.7077 4.56578 17.6295 5.26422 17.9623 6.23454H5.7639C6.09671 5.26422 7.01702 4.56578 8.09827 4.56578H8.09823ZM1.59981 7.69703C1.59981 7.07983 2.10293 6.5767 2.72013 6.5767H4.05765C4.04047 6.72671 4.02953 6.87983 4.02953 7.03451C4.02953 7.47671 4.38734 7.83451 4.82953 7.83451H18.8952C19.3374 7.83451 19.6952 7.4767 19.6952 7.03451C19.6952 6.87982 19.6842 6.72669 19.6671 6.5767H21.003C21.6202 6.5767 22.1233 7.07983 22.1233 7.69703V24.1551C21.3374 23.7941 20.4655 23.5863 19.5452 23.5863C16.1233 23.5863 13.3388 26.3707 13.3388 29.7927C13.3388 30.8755 13.6184 31.8927 14.1075 32.7803H2.71988C2.10268 32.7803 1.59955 32.2756 1.59955 31.6553L1.59981 7.69703Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.14545 14.1954C5.29545 14.347 5.50014 14.4298 5.71109 14.4298C5.73296 14.4298 5.75484 14.4282 5.77671 14.4267C6.01109 14.4079 6.22515 14.286 6.36107 14.0938L8.27516 11.4142C8.53297 11.0548 8.4486 10.5548 8.08922 10.2985C7.72985 10.0422 7.22986 10.1251 6.97358 10.4844L5.60794 12.3969L5.00013 11.7891C4.68763 11.4766 4.18137 11.4766 3.86889 11.7891C3.55641 12.1016 3.55639 12.6079 3.86889 12.9204L5.14545 14.1954Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M10.2529 13.091H19.2921C19.7343 13.091 20.0921 12.7332 20.0921 12.291C20.0921 11.8488 19.7343 11.491 19.2921 11.491H10.2529C9.81068 11.491 9.45288 11.8488 9.45288 12.291C9.45288 12.7316 9.81069 13.091 10.2529 13.091Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.1456 20.041C5.2956 20.191 5.50028 20.2754 5.71124 20.2754C5.73311 20.2754 5.75498 20.2738 5.77686 20.2723C6.01124 20.2535 6.2253 20.1317 6.36122 19.9395L8.27687 17.2598C8.53468 16.9004 8.45031 16.4004 8.09093 16.1441C7.73155 15.8879 7.23157 15.9707 6.97529 16.3301L5.60964 18.2426L5.00184 17.6348C4.68934 17.3223 4.18308 17.3223 3.8706 17.6348C3.55812 17.9473 3.5581 18.4535 3.8706 18.766L5.1456 20.041Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M10.2529 18.9346H19.2921C19.7343 18.9346 20.0921 18.5768 20.0921 18.1346C20.0921 17.6924 19.7343 17.3346 19.2921 17.3346H10.2529C9.81068 17.3346 9.45288 17.6924 9.45288 18.1346C9.45288 18.5768 9.81069 18.9346 10.2529 18.9346Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.14545 25.8862C5.29545 26.0378 5.50014 26.1206 5.71109 26.1206C5.73296 26.1206 5.75484 26.1191 5.77671 26.1175C6.01109 26.0987 6.22515 25.9769 6.36107 25.7847L8.27516 23.105C8.53297 22.7456 8.4486 22.2456 8.08922 21.9894C7.72985 21.7331 7.22986 21.8159 6.97358 22.1753L5.60794 24.0878L5.00013 23.48C4.68763 23.1675 4.18137 23.1675 3.86889 23.48C3.55641 23.7925 3.55639 24.2987 3.86889 24.6112L5.14545 25.8862Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M10.2529 24.7798H13.4404C13.8826 24.7798 14.2404 24.422 14.2404 23.9798C14.2404 23.5377 13.8826 23.1798 13.4404 23.1798H10.2529C9.81068 23.1798 9.45288 23.5377 9.45288 23.9798C9.45288 24.422 9.81069 24.7798 10.2529 24.7798Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M12.9815 3.81897C12.9815 5.30806 10.7456 5.30806 10.7456 3.81897C10.7456 2.32833 12.9815 2.32833 12.9815 3.81897Z",
      fill: color
    }, void 0)]
  }), void 0);
});